<template>
  <router-view />
</template>

<script>
export default {
  name: "Default",
};
</script>
